import { ROP } from '../types';
export default {
  type: ROP,
  service: 'infura.io',
  url: 'https://ropsten.infura.io/mew',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
